export const RouterContexts = {
  PORTAL_CONTEXT: 'portalContext',
  DAILY_AGENDA_CONTEXT: 'dailyAgendaContext',
} as const
